import { NotificationTriggersPage } from "@/pages/settings/NotificationTriggersPage";

/** SC communications module — notification triggers at module scope. */
export function CommunicationsPage() {
  return <NotificationTriggersPage surface="module" />;
}
